import * as Util from '../../../util';
import { useQuery } from 'react-query';
import api from '../../../Api';
import Title from '../../../types/Title';
import CacheKeysEnum from '../../../CacheKeysEnum';

type ReviewCopiesDataType = {
	titles: Title[];
	skus: string[];
};

type UseReviewCopiesType = {
	refetch: () => void;
	data: ReviewCopiesDataType;
	isLoading: boolean;
	isFetching: boolean;
};

const initialReviewCopiesData = {
	titles: [],
	skus: [],
};

export default function useReviewCopies(
	communityId: number,
	numberOfRows: number,
): UseReviewCopiesType {
	const { data, refetch, isLoading, isFetching } = useQuery(
		CacheKeysEnum.NewReviewCopies,
		fetchReviewCopyData,
		{
			refetchOnMount: 'always',
		},
	);

	async function fetchReviewCopyData(): Promise<ReviewCopiesDataType> {
		const reviewCopiesResponse = await fetchReviewCopies();
		const reviewCopies = transformReviewCopiesData(reviewCopiesResponse);
		return reviewCopies;
	}

	function fetchReviewCopies(): Promise<any> {
		return api.get(
			`/api/v1/affiliations/${communityId}/reviewCopies/${numberOfRows}`,
		);
	}

	function transformReviewCopiesData(data: {}): {
		titles: Title[];
		skus: string[];
	} {
		const titles = data && Util.createTitleObject(data);
		return {
			titles,
			skus: getSkus(titles),
		};
	}

	function getSkus(titles: Title[]) {
		if (Array.isArray(titles)) {
			return titles.map(item => item.sku);
		}
		return [];
	}

	return {
		refetch,
		data: data ?? initialReviewCopiesData,
		isLoading,
		isFetching,
	};
}
